import { createContext, useContext } from 'react';
export const ScrollLockManagerContext = createContext(undefined);
export function useScrollLockManager() {
    const scrollLockManager = useContext(ScrollLockManagerContext);
    if (!scrollLockManager) {
        throw new Error('No ScrollLockManager was provided.');
    }
    return scrollLockManager;
}
//# sourceMappingURL=useScrollLockManager.js.map